module.exports = __webpack_public_path__ + "img/girl_icon.943b686e.png";